<template>
	<div class="case-index">
		<!-- 搜索 -->
		<div class="search">
			<div class="search-input">
				<van-search placeholder="请输入搜索关键词" v-model="searchKeyWord" @search="goSearch"/>
			</div>
			<router-link to="">我要投稿</router-link>
		</div>
		<!-- 轮播图 -->
		<banner :type="4"></banner>
		<!-- 亚专业 -->
		<div class="major">
			<h3>亚专业</h3>
			<div class="content">
				<span class="line-clamp-1" v-for="(item,index) in majorData" :key="index" @click="skipArticlesList(item.id)">{{item.name}}</span>
			</div>
		</div>
		<div class="hr-7"></div>
		<div class="articlesWrap" v-if="articlesList.length>0">
			<h3>文章</h3>
			<div class="container">
				<van-list
					v-model="loading"
					:finished="finished"
					finished-text="没有更多了"
					@load="pullUpLoading"
					>
					<template v-for="(item) in articlesList">
						<item-block :itemContent="item" :key="item.id"></item-block>
					</template>
				</van-list>
			</div>
		</div>
	</div>
</template>
<script>
	// import ColumnItemList from "../../components/ColumnItemList";
	import Banner from "../../components/Banner"
	import {ModulesRecommend,CaseAllArticles,CaseMajor,ModulesDetails} from "../../config/interface.js"
	import ItemBlock from '../../components/ItemBlock.vue';
	export default{
		components:{
			Banner,
			ItemBlock
		},
		data(){
			return{
				type:4,   //1:专栏模块; 2:会议模块; 3:前沿资讯模块;4:病例模块;5:器械模块
				swiperImg:[],     //轮播图
				articlesList:[],    //文章列表
				majorData:[],	  //亚专业
				searchKeyWord:'',     //关键词
				limit:8,
				page:1,
				finished:false,
				loading:false

			}
		},
		mounted(){
			this.getSwiper();
			this.getMajor();
			this.queryArticles();
			//微信浏览器  请求jsdk
			if(common.is_weixin()){
				common.moduleDetails(4);
			}
		},
		methods:{
			
			//得到轮播图
			getSwiper(){
				this.$store.dispatch('isShowLoading',true);
				const url=ModulesRecommend;
				const method='POST';
				let params={
					module_id:4   //病例模块
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.swiperImg=data;
					}
					this.$store.dispatch('isShowLoading',false);
				})
			},
			//亚专业
			getMajor(){
				const url=CaseMajor;
				const method='POST';
				let params={};
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.majorData=data;
					}
				})
			},
			//跳转到文章课表
			skipArticlesList(id){
				this.$router.push({
					path:'/case/list',
					query:{
						id:id
					}
				})
			},
			//上拉加载
			pullUpLoading(){
				setTimeout(()=>{
					this.page++;
					this.queryArticles();
				},500)
			},
			//所有文章
			queryArticles(){
				const url=CaseAllArticles;
				const method='POST';
				let params={
					limit:this.limit,
					page:this.page
				};
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data.data;
						this.loading=false;
						data.forEach((item,index)=>{
							this.articlesList.push(item);
						})
						if(data.length<this.limit){
							this.finished=true;
						}
						
					}
				})
			},
			//去搜索
			goSearch(){
				this.$router.push({
					path:'/case/search',
					query:{
						searchKeyWord:this.searchKeyWord
					}
				})				
			}
		}
	}
</script>
<style  lang="scss">
	.case-index{
		/*搜索*/
		.search{
			padding-right:12px;
			@include flex(row);
			align-items:center;
			justify-content:space-between;

			a{
				color:$color-main;
				font-size:15px;
				letter-spacing:0.53px;
				font-weight:700;
			}
			.search-input{			
				flex:1;
				.van-search__content{
					background: #F2F2F2;
					border: 1px solid #D3D3D3;
					border-radius:20px;
					::-webkit-input-placeholder,i{
						color:#999;
						font-size:14px;
					}
					i{
						font-size:20px;
					}
				}
			}
		}
		/*轮播图*/
		.swiper-img{
			height:150px;
			img{
				width:100%;
				height:150px;
			}
		}
		h3{
			height:50px;
			line-height:50px;
			font-size: 17px;
			color: #090909;
			letter-spacing: 0.6px;

		}
		/*亚专业*/
		.major{
			padding:0 12px;
			.content{
				@include flex(row);
				flex-wrap: wrap;
					span{
						margin-right:5px;
						padding:0 3px;
						box-sizing:border-box;
						width:23%;
						margin:0 1% 10px;
						height:30px;
						line-height:30px;
						text-align:center;
						font-size: 12px;
						color: #090909;
						letter-spacing: 0.42px;
						border: 1px solid #D3D3D3;
						border-radius: 2px;
						margin-bottom: 10px;
					}
			}
		}
		.articlesWrap{
			padding:0 14px;
			h3{
				height:30px;
				// line-height:30px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/Case/index.vue